import * as React from 'react';

import * as styles from './ContactsBlock.css';

export interface IContactsBlockProps {
  callbackButton?: React.ReactNode;
  phoneButton?: React.ReactNode;
}

export const ContactsBlock: React.FC<IContactsBlockProps> = ({ callbackButton, phoneButton }) => {
  return (
    <div className={styles['contacts']}>
      {phoneButton && <div className={styles['button']}>{phoneButton}</div>}
      {callbackButton && <div className={styles['button']}>{callbackButton}</div>}
    </div>
  );
};
